import React, { useEffect } from 'react';
import { Row, Form, Card, InputNumber } from 'antd';
import FormInput from 'components/FormInput';
import { ParServiceResponse } from 'services/pricing';
import ParListSelect from 'components/ParListSelect';
import InputCurrency from 'components/InputCurrency';
import InputRate from 'components/InputRate';
import TextArea from 'antd/lib/input/TextArea';
import { FormInstance } from 'antd/es/form';

type ServiceUseProps = {
  service: ParServiceResponse;
  form: FormInstance;
};

const ServiceUse = (props: ServiceUseProps) => {
  const { service, form } = props;

  useEffect(() => {
    if (service) {
      form.setFieldsValue({
        servuseunit: service.servuseunit,
        servusefrequency: service.servusefrequency,
        servuseminamount: service.servuseminamount,
        servusemaxamount: service.servusemaxamount,
        servuseqty: service.servuseqty,
        servusecoverage: service.servusecoverage,
        servusedeductionamount: service.servusedeductionamount,
        servusedeductionpercenrage: service.servusedeductionpercenrage,
        servdescription: service.servdescription,
      });
    }
  }, [form, service]);

  return (
    <Card>
      <Row gutter={16}>
        <FormInput col xs={8} name="servuseunit">
          <ParListSelect parcode="SUSEUNIT" />
        </FormInput>

        <FormInput col xs={8} name="servusefrequency">
          <ParListSelect parcode="SUSEFREQ" />
        </FormInput>
        <FormInput col xs={8} name="servuseqty">
          <InputNumber />
        </FormInput>
      </Row>
      <Row gutter={16}>
        <Form.Item name="servuseminamount" noStyle>
          <FormInput col xs={8} name="servuseminamount">
            <InputCurrency
              currcode={form?.getFieldValue('currcode')}
              name="servuseminamount"
            />
          </FormInput>
        </Form.Item>
        <Form.Item name="servusemaxamount" noStyle>
          <FormInput col xs={8} name="servusemaxamount">
            <InputCurrency
              currcode={form?.getFieldValue('currcode')}
              name="servusemaxamount"
            />
          </FormInput>
        </Form.Item>

        <FormInput col xs={8} name="servusecoverage">
          <InputRate />
        </FormInput>
      </Row>
      <Row gutter={16}>
        <Form.Item name="servusedeductionamount" noStyle>
          <FormInput col xs={8} name="servusedeductionamount">
            <InputCurrency
              currcode={form?.getFieldValue('currcode')}
              name="servusedeductionamount"
            />
          </FormInput>
        </Form.Item>

        <FormInput col xs={8} name="servusedeductionpercenrage">
          <InputRate />
        </FormInput>
      </Row>
      <Row>
        <FormInput col xs={24} name="servdescription" comcode="servdescription">
          <TextArea rows={7} />
        </FormInput>
      </Row>
    </Card>
  );
};

export default ServiceUse;
